
export default function Security() {
  return (
    <section id="security" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">Bank-Level Security for Your Peace of Mind</h2>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              IMPRIME VPN uses the same encryption standards trusted by banks and governments worldwide. Your online activities are protected by military-grade AES-256 encryption, ensuring that your data remains completely private and secure.
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-lock-2-line text-blue-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">AES-256 Encryption</h3>
                  <p className="text-gray-600">The highest level of encryption available, used by security experts worldwide to protect sensitive information.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-eye-off-line text-purple-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Zero Logging</h3>
                  <p className="text-gray-600">We don't track, collect, or store any of your browsing data. What you do online stays completely private.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-pink-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-flash-line text-pink-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Kill Switch Protection</h3>
                  <p className="text-gray-600">Automatically blocks all internet traffic if your VPN connection drops, preventing any data leaks.</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-fingerprint-line text-indigo-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">DNS Leak Protection</h3>
                  <p className="text-gray-600">Ensures your DNS requests are encrypted and routed through our secure servers, not your ISP.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/25df9ec877dc8da53b00018d5c1014ac.jpg"
              alt="VPN Security Technology"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover"
            />
            <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-6 max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-shield-check-fill text-white text-2xl"></i>
                </div>
                <div>
                  <p className="text-sm text-gray-600 whitespace-nowrap">Connection Status</p>
                  <p className="text-lg font-bold text-gray-900 whitespace-nowrap">Fully Protected</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
